import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "scl" }
const _hoisted_2 = { class: "scl__hero" }
const _hoisted_3 = { class: "scl__hero-row" }
const _hoisted_4 = { class: "scl__main" }
const _hoisted_5 = {
  key: 0,
  class: "scl__state"
}
const _hoisted_6 = {
  key: 1,
  class: "scl__state scl__state--error"
}
const _hoisted_7 = {
  key: 2,
  class: "scl__empty"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 3,
  class: "scl__list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "scl__org" }
const _hoisted_12 = { class: "scl__meta" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "scl__tags" }
const _hoisted_17 = { class: "scl__tag" }
const _hoisted_18 = { class: "scl__tag" }
const _hoisted_19 = { class: "scl__tag" }
const _hoisted_20 = { class: "scl__when" }
const _hoisted_21 = ["onClick"]

import { illust } from '@/constants/illust'
import type { ServiceContractListItem } from '@/api/serviceContract'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractList',
  props: {
    items: {},
    loading: { type: Boolean },
    error: {}
  },
  emits: ["create", "open", "remove", "refresh"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function selectLabel(value: string) {
  if (value === 'selected') return '선택'
  if (value === 'unselected') return '미선택'
  return '미정'
}

function formatWhen(value: string) {
  const text = String(value || '').replace('T', ' ')
  return text.slice(0, 16) || '—'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "scl__eyebrow" }, "HAMWOORI / SERVICE AGREEMENT", -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "scl__title" }, "계약서 목록"),
          _createElementVNode("p", { class: "scl__lead" }, "어느 기관과 계약했는지 여기에 남습니다. 항목을 누르면 그 계약서를 이어서 수정합니다.")
        ], -1)),
        _createElementVNode("button", {
          type: "button",
          class: "scl__new",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('create')))
        }, "새 계약서")
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      (__props.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "목록을 불러오는 중…"))
        : (__props.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(__props.error) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "scl__retry",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('refresh')))
              }, "다시 시도")
            ]))
          : (!__props.items.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  class: "scl__empty-img",
                  src: _unref(illust).empty,
                  alt: ""
                }, null, 8, _hoisted_8),
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "scl__empty-title" }, "아직 저장된 계약서가 없습니다", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "scl__empty-text" }, "새 계약서를 만들면 기관 이름과 함께 이 목록에 쌓입니다.", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "scl__new",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('create')))
                }, "새 계약서")
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.id,
                    class: "scl__item"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "scl__open",
                      onClick: ($event: any) => (emit('open', item.id))
                    }, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.orgName || '기관명 없음'), 1),
                      _createElementVNode("span", _hoisted_12, [
                        (item.facilityCode)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "기관기호 " + _toDisplayString(item.facilityCode), 1))
                          : _createCommentVNode("", true),
                        (item.representative)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "대표 " + _toDisplayString(item.representative), 1))
                          : _createCommentVNode("", true),
                        (item.legalName)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.legalName), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, "임금 " + _toDisplayString(selectLabel(item.wageSelect)), 1),
                        _createElementVNode("span", _hoisted_18, "회계 " + _toDisplayString(selectLabel(item.acctSelect)), 1),
                        _createElementVNode("span", _hoisted_19, "별첨 2 " + _toDisplayString(item.annex2Mode === 'text' ? '텍스트' : '양식'), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["scl__tag", { 'is-on': item.hasSign }])
                        }, _toDisplayString(item.hasSign ? '서명 있음' : '서명 없음'), 3)
                      ]),
                      _createElementVNode("span", _hoisted_20, "수정 " + _toDisplayString(formatWhen(item.updatedAt)), 1)
                    ], 8, _hoisted_10),
                    _createElementVNode("button", {
                      type: "button",
                      class: "scl__delete",
                      onClick: ($event: any) => (emit('remove', item))
                    }, "삭제", 8, _hoisted_21)
                  ]))
                }), 128))
              ]))
    ])
  ]))
}
}

})